class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.invoice = document.querySelector('cart-invoice');
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    console.log(cartLink);
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    /* Note */
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    /* ATOMS-INVOICE-MOD-REQ-2025-11: Check invoice */
    const cartDrawerInvoice = this.querySelector('.cart__invoice-input');
    const cartDrawerEdit = this.querySelector('.cart__invoice-edit');
    if (cartDrawerInvoice) this.enableCartInvoice(cartDrawerInvoice, cartDrawerEdit);
    console.log('Open');
    console.log(cartDrawerEdit);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  /* ATOMS-INVOICE-MOD-REQ-2025-11: Check Invoid */
  enableCartInvoice(cartDrawerInvoice, cartDrawerEdit) {
    console.log('click change');
    cartDrawerInvoice.addEventListener('change', (event) => {
      var attributes = {};
      if ( event.target.checked == true) {
        cartDrawerEdit.classList.add("active");
      } else if( event.target.checked == false) {
        cartDrawerEdit.classList.remove("active");
      }
    });
  }
  
  renderContents(parsedState) {
    console.log('RENDER D');
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ATOMS-INVOICE-MOD-REQ-2025-11: Check invoice */
if (!customElements.get('cart-check-invoice')) {
  customElements.define('cart-check-invoice', class CartDrawerCheck extends HTMLElement {
    constructor() {
      super();
      this.invoice = document.querySelector('cart-invoice');

      this.addEventListener('change', (event) => {
        console.log('changeCOntent');
        console.log(event.target.checked);
        var attributes = {};
        if ( event.target.checked == true) {
          attributes = {"attributes_enable_invoice": "true"};
          this.invoice.undapteInvoice(attributes, true);
        } else if( event.target.checked == false) {
          attributes = {
            "attributes_enable_invoice": "false",
            "attributes_rfc": null,
            "attributes_name": null,
            "attributes_regimen": null,
            "attributes_CFDI": null,
            "attributes_codigo_postal": null,
            "attributes_metodo": null,
            "attributes_regimen_text": null,
            "attributes_CFDI_text": null,
            "attributes_metodo_text": null
          };
          this.invoice.undapteInvoice(attributes, false);
          
          const open_invoice = document.querySelector('cart-open-invoice');
          open_invoice.classList.remove('is-hidden');
        }
      });
    }
  });
};
/* ATOMS-INVOICE-MOD-REQ-2025-11: Open invoice */
if (!customElements.get('cart-open-invoice')) {
  customElements.define('cart-open-invoice', class CartDrawerOpen extends HTMLElement {
    constructor() {
      super();
      this.invoice = document.querySelector('cart-invoice');
      var attributes = {};
      this.addEventListener('click', (event) => {
        console.log('Abrir');
        event.preventDefault();

        // attributes = {"attributes_enable_invoice": "true"};
        // this.invoice.undapteInvoice(attributes, true);

        this.invoice.open(this);
      });
    }
  });
};
/* ATOMS-INVOICE-MOD-REQ-2025-11: Edit invoice */
if (!customElements.get('cart-edit-invoice')) {
  customElements.define('cart-edit-invoice', class CartDrawerEdit extends HTMLElement {
    constructor() {
      super();
      this.invoice = document.querySelector('cart-invoice');

      this.addEventListener('click', (event) => {
        console.log('Entra');
        event.preventDefault();
        this.invoice.open(this);
      });
    }
  });
};
/* ATOMS-INVOICE-MOD-REQ-2025-11: RFC invoice */
if (!customElements.get('cart-rfc-invoice')) {
  customElements.define('cart-rfc-invoice', class CartDrawerRFC extends HTMLElement {
    constructor() {
      super();

      const toggleRFC = this.querySelector('#cartIconRFC');
      const inputRFC = this.querySelector('#cartInputRFC');

      toggleRFC.addEventListener('click', function (e) {
          // toggle the type attribute
          const type = inputRFC.getAttribute('type') === 'password' ? 'text' : 'password';
          inputRFC.setAttribute('type', type);
          
          // toggle the eye icon class
          this.classList.toggle('is-slash');
      });
    }
  });
};
